var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_152",
    "data-name": "Line 152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    fill: "#b5b5b5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusGrey);
export default __webpack_public_path__ + "static/media/minus-grey.0cce02924a2903415f5d855fdfc1fb09.svg";
export { ForwardRef as ReactComponent };